export default __webpack_public_path__ + "static/media/ham-menu.eddf634f.svg";